<template>
    <div>
        <div class="card card-next-class-2" v-if="classStudent != null">
            <div class="left">
                <img src="@/assets/img/girdRequest-2.png">
                <h6 class="sub-title"><span>{{$t('horario.next-class.nextClass')}}</span></h6>
            </div>
            <div>
                <div class="right">
                    <span><icon name="calendar" />{{classStudent.strStartDate}}</span>
                    <span><icon name="time" />{{classStudent.strStartEndDate}}</span>
                    <span style="white-space: normal;">
                        <icon v-if="classStudent.flagGroup" name="group" style="width: 17px;" />
                        <icon v-else name="user-2" style="width: 17px;"/>
                        {{classStudent.className}}
                    </span>
                </div>
            </div>
            <button type="button"   @click="openLinkClassLocal(classStudent.linkClass,$moment,classStudent.startDateValidate,classStudent.endDateValidate)" class="btn btn-primary" :class="classStudent && classStudent.linkClass != null? '': 'disabled'" >
                <icon name="video" /> {{$t('horario.next-class.join')}}
            </button>
                        <!-- <b-button variant="primary"><b-icon icon="camera-video" aria-hidden="true"></b-icon>{{$t('horario.next-class.button-pass')}}</b-button> -->
        </div> 
    </div>
</template>

<script>

import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import * as Constants from "@/assets/js/appConstants";
import { horarioObtenerColorClase,horarioObtenerNameClaseEN,openLinkClass, getNextClassDate,getNextClassTime, convertTimeToUserTimeFormat } from '@/assets/js/util.js';
export default {
    components: {

    },
    data(){
        return{
            lang: localStorage.getItem('lang'),
            messageLinkClassResult:null,
            classStudent: null,
            filterStudent: "",
            currentPage: 1,
            pageSize: 5,
            totalRows: 0,
            transProps: {
            // Transition name
                name: 'flip-list'
            },
            isBusy:false,
            optionsReport: [],
            optionsStatus : [],
            selectedStatus: null,
            selectedReport : null,
            itemsTable:[],
            dateRange: {startDate:null, endDate :null},
            /*value: '',
            suggestionAttribute: 'descripcion',
            suggestions: [],
            selectedEvent: "",*/
            item: null,
            items: [],
        }
    },
    computed: {
       
        groupId:{
            get() {
                return this.$store.state.group_id;
            },
            set(value) {
                this.$store.commit("mutateGroupId", value);
            } 
            },
        User: {
            get() {
                return this.$store.state.user;
            },
        }
    },
    created(){
        this.getListClassTeacher();
	},
	mounted(){
        
	},
    methods: {
        getListClassTeacher() {
            let data = {
                PersonTeacherId : this.User.personTeacherId,
                isNextClass : true,
                 groupId: 0
            }
            let format_time_validate = "YYYY-MM-DDTHH:mm:ss";
            let format_day = "MM/DD/YYYY";
            let format_time = "h:mm a";

			baseInstanceAxios
				.get(`${this.apiURL}/resources/PersonsTeachers/GetComboScheduleTeacherDetailClass`, {params: data})
				.then((response) => {
                    this.totalRows = response.data.rows;
                   
                    if(response.data.entity.teacherScheduleClass != null){
                            
                          this.classStudent = {
                            className : response.data.entity.teacherScheduleClass.className,
                            classPhoto : response.data.entity.teacherScheduleClass.classPhoto,
                            flagGroup:  response.data.entity.teacherScheduleClass.flagGroup,
                            //strStartDate : response.data.entity.teacherScheduleClass.strStartDate_EN,
                            //strStartEndDate : response.data.entity.teacherScheduleClass.strStartEndDate,
                            strStartDate : getNextClassDate(response.data.entity.teacherScheduleClass.startDate, this.$store.state.user.timeZoneName, this.$moment, format_day),
                            strStartEndDate : getNextClassTime(response.data.entity.teacherScheduleClass.startDate, response.data.entity.teacherScheduleClass.endDate, this.$store.state.user.timeZoneName, this.$moment, format_time),
                            linkClass : response.data.entity.teacherScheduleClass.linkClass,
                            //startDateValidate : response.data.entity.teacherScheduleClass.startDate,
                            //endDateValidate : response.data.entity.teacherScheduleClass.endDate,
                            startDateValidate: convertTimeToUserTimeFormat(response.data.entity.teacherScheduleClass.startDate, this.$store.state.user.timeZoneName, this.$moment, format_time_validate)  ,
                            endDateValidate: convertTimeToUserTimeFormat(response.data.entity.teacherScheduleClass.endDate, this.$store.state.user.timeZoneName, this.$moment, format_time_validate)   ,
                        }
                    }
			});
		},
        openLinkClassLocal(linkClass,moment,startDate,endDate){
           this.messageLinkClassResult = null;
           let result = openLinkClass(linkClass,moment,startDate,endDate,this.$store.state.user.timeZoneName);
           if(result!=""){
           this.messageLinkClassResult = result;
           this.$bvModal.show("modal-next-linkClass");
           }
        },
	}
}
</script>